import React, { Component } from 'react';
import Footercontent from './Footercontent';

class Footerthree extends Component {
    render() {
        return (
            <footer className="acr-footer footer-dark">
                <Footercontent/>
            </footer>
        );
    }
}

export default Footerthree;